.styledButton {
  border-radius: 50%;

  &.isActive {
    color: var(--text-success);
    border-color: var(--border-success);

    svg {
      fill: var(--icon-success);
    }
  }
}
